export const MEMBERSHIP_UI_VISIBLE = false;
